import {
  Store,
  addListener,
  configureStore,
  createListenerMiddleware,
} from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import appReducer from '../reducers/app/appReducer';
import contactReducer from '../reducers/contact/contactReducer';
import errorReducer from '../reducers/error/errorReducer';
import searchReducer from '../reducers/search/searchReducer';
import servicesReducer from '../reducers/services/servicesReducer';
import storesReducer from '../reducers/stores/storesReducer';
import timeSlotsReducer from '../reducers/timeslots/timeSlotsReducer';
import userReducer from '../reducers/user/userReducer';

const listenerMiddlewareInstance = createListenerMiddleware();

export function makeStore(initListenersFunc: () => void) {
  initListenersFunc();
  return configureStore({
    reducer: {
      app: appReducer,
      contact: contactReducer,
      error: errorReducer,
      search: searchReducer,
      services: servicesReducer,
      stores: storesReducer,
      timeSlots: timeSlotsReducer,
      user: userReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().prepend(listenerMiddlewareInstance.middleware),
  });
}

export type RootState = ReturnType<ReturnType<typeof makeStore>['getState']>;
export type AppDispatch = ReturnType<typeof makeStore>['dispatch'];
export type StoreType = Store<RootState>;
export const useStateSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useStateDispatch: () => AppDispatch =
  useDispatch.withTypes<AppDispatch>();
export const addAppListener = addListener.withTypes<RootState, AppDispatch>();
export const startAppListening =
  listenerMiddlewareInstance.startListening.withTypes<RootState, AppDispatch>();
export type StartAppListeningFunction = typeof startAppListening;
